import React, { Component } from "react";
import PropTypes from "prop-types";

import IntervalPromise from "./../../../util/interval-promise/IntervalPromise";

class IntervalManager extends Component {
  componentDidMount() {
    const { timeBetweenFetchInSeconds, action, maxRetries } = this.props;
    this.stopInterval();
    this.intervalPromise = IntervalPromise.create({
      timeBetweenIterations: timeBetweenFetchInSeconds * 1000,
      action: () => action(),
      maxRetries
    });
  }

  componentWillReceiveProps(nextProps) {
    const { startFetch, stopFetch } = this.props;
    setTimeout(() => {
      if (!startFetch && nextProps.startFetch) {
        this.executeOnInterval();
      }
      if (!stopFetch && nextProps.stopFetch) {
        this.stopInterval();
      }
    }, 0);
  }

  componentWillUnmount() {
    setTimeout(() => {
      this.stopInterval();
    }, 0);
  }

  render() {
    return null;
  }

  executeOnInterval() {
    if (this.intervalPromise) {
      this.intervalPromise
        .doUntilCondition()
        .then(() => this.props.onExit())
        .catch(res => this.props.onFail(res));
    }
  }

  stopInterval() {
    if (this.intervalPromise) {
      this.intervalPromise.destroy();
    }
  }
}

IntervalManager.defaultProps = {
  timeBetweenFetchInSeconds: 30,
  startFetch: false,
  stopFetch: false,
  onExit: () => {},
  onFail: () => {}
};

IntervalManager.propTypes = {
  timeBetweenFetchInSeconds: PropTypes.number,
  action: PropTypes.func.isRequired,
  startFetch: PropTypes.bool,
  stopFetch: PropTypes.bool,
  maxRetries: PropTypes.number,
  onExit: PropTypes.func,
  onFail: PropTypes.func
};

export default IntervalManager;
